import React, { useContext } from 'react';
import { CloseOutlined, Icon } from '..';
import { ModalContext } from './context';
export function ModalClose() {
  var _useContext = useContext(ModalContext),
      onHide = _useContext.onHide;

  return /*#__PURE__*/React.createElement(Icon, {
    onClick: onHide,
    ml: "auto",
    p: "xs",
    component: CloseOutlined,
    size: 24,
    color: "grey.darker",
    "data-test": "modal-close-icon"
  });
}